import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import UserService from "../../services/UserService";
import Loader from "../Loader/Loader";
import AccountsService from "../../services/AccountsService";
import AwsApiService from "../../services/AwsApiService";
import GoogleAnalytics from "../../analytics/GoogleAnalytics";
import CouponsService from "../../services/CouponsService";
import GenericError from "../Utilities/GenericError";
import PopUp from "../Utilities/PopUp";
import {useLoading} from "../../context/LoadingContext";
import {useAuth} from "../../context/AuthContext";
import PhoneVerification from "./PhoneVerification/PhoneVerification";
import ProductsService from "../../services/ProductsService";
import {useAccount} from "../../context/AccountContext";
import usePaymentProvider from "../../services/PaymentProvider.ts";
import {Trans, useTranslation} from "react-i18next";
import {Button, Link} from "@mui/material";
import {COMPLEMENTARY_PRODUCTS} from "../Account/utils";
import jwt_decode from "jwt-decode";

function PickProgram() {
  const provider = usePaymentProvider();

  let navigate = useNavigate();
  const { t } = useTranslation();
  const account = useAccount();

  const {isLoading, addLoading, removeLoading} = useLoading();
  const {loggedIn, authData} = useAuth()
  let location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const flow = queryParams.get("flow");
  const token = queryParams.get("token");//token from scheduled save desk

  const [verificationSent, setVerificationSent] = useState(false);

  const [phoneNumberVerifyToken, setPhoneNumberVerifyToken] = useState("");
  // const [phoneNum, setPhoneNum] = useState();

  const [genericError, setGenericError] = useState(false);
  const [complementaryError, setComplementaryError] = useState(false);

  const shouldShowVerifyEmailPopup = () => {
    const kcAction = sessionStorage.getItem("kc_action");
    if (!kcAction) {
      return false;
    }

    try {
      return jwt_decode(JSON.parse(kcAction).token)?.emailVerified !== true;
    } catch (error) {
      return false;
    }
  }

  const checkSubscriptionAction = async () => {
    if (UserService.isSubscriptionAction()) {
      // user is not initialized fully yet
      AwsApiService.onRegisterConfirm();
      GoogleAnalytics.onRegisterConfirm();

      try {
        const response = await AccountsService.checkSubscriptionPostAction();
        if ([2].includes(response.data.code)) {//todo check this
          UserService.resolveSubscriptionAction(response.data.token, false);
          return;
        }
        if([4].includes(response.data.code)) {
          sessionStorage.setItem("kc_resolve_token", response.data.token);
          navigate("/CongratsPage");
          return;
        }
        if ([5].includes(response.data.code)){
          navigate(`/Questionnaire?q=${process.env.REACT_APP_REGISTRATION_QUESTIONNAIRE}`)
          return;
        }

        setVerificationSent(shouldShowVerifyEmailPopup())
        return true;
        // removeLoading("INIT");
      }catch (error){
        if ([44].includes(error?.response?.data?.code)) {//case unauthorized, invalid token
          navigate("/");
        } else if ([403].includes(error?.response?.data?.code)) {
          if (error?.response?.data?.token) { //phone verification flow
            if(!UserService.getOTPFromActionToken()){
              setPhoneNumberVerifyToken(error?.response?.data?.token)
            }
            return true;
          } else {
            //todo error return from back
          }
        }
      }
    } else {
      return true;
      // removeLoading("INIT")
    }
  }


  const [FlowElement, setFlowElement] = useState(<></>)


  const checkFlow = async () => {
    // let couponExists = false;
    if(!!authData.error && authData.error === 303){
      throw new Error();
    }
    if(COMPLEMENTARY_PRODUCTS.includes(authData?.productName)){
      const error = new Error('Complementary product found');
      error.code = 401;
      throw error;
    }
    let couponInfo = undefined;
    if (sessionStorage.getItem("discount-coupon")) {
      addLoading("PICKCOUPON")
      await CouponsService.getCouponProduct(sessionStorage.getItem("discount-coupon"))
          .then((response) => {
            couponInfo = response.data.references;
          })
          .catch((error) => {
            couponInfo = [];
            if(error.response.status !== 404){
              console.log("Error on getting coupon information");
            }
          })
          .finally(() => {
            removeLoading("PICKCOUPON")
          })
    }


    let promoRedirectURL;
    let promoTargetDisplayName;
    if (sessionStorage.getItem("promoRedirectURL")) {
      //flow promo
      promoRedirectURL = sessionStorage.getItem("promoRedirectURL")
      promoTargetDisplayName = sessionStorage.getItem("promoTargetDisplayName")

      sessionStorage.removeItem("promoRedirectURL")
      sessionStorage.removeItem("promoTargetDisplayName")
    }

    let contestSession;
    let contestRedirectURL;
    if (sessionStorage.getItem("contestSession")) {
      //flow contest
      contestSession = sessionStorage.getItem("contestSession")
      contestRedirectURL = sessionStorage.getItem("contestRedirectURL");

      sessionStorage.removeItem("contestSession");
      sessionStorage.removeItem("contestRedirectURL");
    }

    const handleNextStep = (isTrue)=> {
      if(isTrue){
        if(promoRedirectURL) {//pass promo information
          sessionStorage.setItem("congratsRedirectURL", promoRedirectURL)
        }
      }else{
        if(promoRedirectURL){//pass promo information
          sessionStorage.setItem("promoRedirectURL", promoRedirectURL)
        }

        if(contestSession){//pass contest information
          sessionStorage.setItem("contestSession", contestSession)
          sessionStorage.setItem("contestRedirectURL", contestRedirectURL)
        }
      }
    }

    if (token) {
      //flow token
      const response = await ProductsService.getProducts((token !== null ? {token: token} : {}))
          .then((response) => {
            return response.data.packages
          })
          .catch((error) => {
            return [];
          })

      setFlowElement(<provider.MigrationFlow packages={response}
                                    couponExists={sessionStorage.getItem("discount-coupon")}
                                    promoTargetDisplayName={promoTargetDisplayName}
                                    promoRedirectURL={promoRedirectURL}
                                    contestSession={!!contestSession}
                                    flow={"unknown"}
                                    handleNextStep={handleNextStep}
                                    token={token}
      />)
    } else if (flow && flow === "newsletter") {
      //flow newsletter
      const response = await ProductsService.getProductReferenceStandalone({
        productId: !!authData.productId
            ? authData.productId
            : -1,
        pricePoint: !!authData.pricePoint ? authData.pricePoint : undefined,
        flow: "newsletter"
      })

      setFlowElement(<provider.MigrationFlow packages={response.data}
                                    couponExists={sessionStorage.getItem("discount-coupon")}
                                    promoTargetDisplayName={promoTargetDisplayName}
                                    promoRedirectURL={promoRedirectURL}
                                    contestSession={!!contestSession}
                                    flow={"newsletter_save_desk"}
                                    handleNextStep={handleNextStep}
      />)
    } else if (!!authData.subscriptionId || (!(!!UserService.isSubscriptionAction()) && !!sessionStorage.getItem("discount-coupon"))) {
      //flow already has a subscription or has coupon upon registration

      if(!!couponInfo) { //coupon exists
        setFlowElement(<provider.MigrationFlow packages={couponInfo}
                                      couponExists={sessionStorage.getItem("discount-coupon")}
                                      flow={"migrate"}
                                      handleNextStep={handleNextStep} />)
      }else { //coupon dosent exist
        if (account.migrateFromCancellation) { //unsubscribe flow
          const response = await ProductsService.getCancellationProductReference({
            productId: authData.productId,
            pricePoint: authData.pricePointHandle,
          })

          setFlowElement(<provider.MigrationFlow packages={response.data}
                                        couponExists={sessionStorage.getItem("discount-coupon")}
                                        promoTargetDisplayName={promoTargetDisplayName}
                                        promoRedirectURL={promoRedirectURL}
                                        contestSession={!!contestSession}
                                        flow={"save_desk"}
                                        handleNextStep={handleNextStep}
                                        cancellationFlow={true}
          />)
        } else {
          const response = await ProductsService.getProductReferenceStandalone({
            productId: !!authData.productId
                ? authData.productId
                : -1,
            pricePoint: !!authData.pricePoint ? authData.pricePoint : undefined,
          })

          setFlowElement(<provider.MigrationFlow packages={response.data}
                                        couponExists={sessionStorage.getItem("discount-coupon")}
                                        promoTargetDisplayName={promoTargetDisplayName}
                                        promoRedirectURL={promoRedirectURL}
                                        flow={"migrate"}
                                        contestSession={!!contestSession}
                                        handleNextStep={handleNextStep}
          />)
        }
      }
    } else {
      //flow just registered or isnt initialized yet
      try {
        if(!!couponInfo) {
          setFlowElement(<provider.RegistrationFlow
              packages={couponInfo} couponExists={sessionStorage.getItem("discount-coupon")}
              promoTargetDisplayName={promoTargetDisplayName} contestSession={!!contestSession}
              handleNextStep={handleNextStep}
          />)
        }else {
          const response = await ProductsService.getProductsStandalone();
          setFlowElement(<provider.RegistrationFlow
              packages={response.data.packages} couponExists={false}
              promoTargetDisplayName={promoTargetDisplayName} contestSession={!!contestSession}
              handleNextStep={handleNextStep}
          />)
        }
        return true;
      }catch (error){
        throw new Error();
      }
    }
  }

  useEffect(() => {
    if(!(isLoading("INIT"))){
      addLoading("INIT")
    }
    if(loggedIn){
      checkSubscriptionAction()
          .then(response => {
            if(response){
              return checkFlow()
            }else{
              throw new Error();
            }
          })
          .then(checkflowResponse => {
            removeLoading("INIT");
          })
          .catch((e)=>{
            if(e.code === 401){
              setComplementaryError(true)
            }else{
              setGenericError(true)
            }
            removeLoading("INIT")
          })
    }
  }, [loggedIn]); //eslint-disable-line react-hooks/exhaustive-deps

  return (<>
          {isLoading() ? (<Loader />) : (
              <>
                {FlowElement}
                <PopUp
                    openPopUp={verificationSent}
                    setOpenPopUp={setVerificationSent}
                    maxWidth="md"
                    showCloseButton={false}
                    outlined={false}
                    error={false}
                    closeWhenClickedOutside={false}
                >
                    <GenericError
                        setClose={setVerificationSent}
                        success={true}
                        mainText={t("pickProgramVerifyEmailPopupTitle")}
                        buttonText={t("pickProgramVerifyEmailPopupCTA")}
                        showIcon={false}

                        // executeFunction={() => navigate("/Account")}
                    >
                        <div className={"verify-email-popup-secondary-wrapper"}>
                            <span className={"verify-email-popup-secondary-first"} >{t("pickProgramVerifyEmailPopupContent1")}</span>
                        </div>
                    </GenericError>
                </PopUp>
                <PopUp
                    openPopUp={genericError}
                    setOpenPopUp={setGenericError}
                    maxWidth="md"
                    showCloseButton={false}
                    outlined={false}
                    error={false}
                    closeWhenClickedOutside={false}
                >
                  <GenericError
                      setClose={setGenericError}
                      success={true}
                      mainText={t("subServiceErrorPopupTitle")}
                      showIcon={false}
                      hideButtons={true}
                  >
                    {t("subServiceErrorPick")}
                    <div className={"subService-error"} style={{display: "flex", flexDirection: "row", marginTop: "24px"}}>
                      <Button
                          variant="text"
                          color="primary"
                          className="grey"
                          onClick={() => {
                            navigate('/');
                          }}>
                        {t("goBackButton")}
                      </Button>
                      <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            navigate(0)
                          }}>
                        {t("subServiceErrorCTA")}
                      </Button>
                    </div>
                  </GenericError>
                </PopUp>
                <PopUp
                    openPopUp={complementaryError}
                    setOpenPopUp={setComplementaryError}
                    maxWidth="md"
                    showCloseButton={false}
                    outlined={false}
                    error={false}
                    closeWhenClickedOutside={false}
                >
                  <GenericError
                      setClose={setComplementaryError}
                      success={true}
                      mainText={t("complementaryFoundErrorPopupTitle")}
                      showIcon={false}
                      hideButtons={true}
                  >
                    <span>
                      <Trans i18nKey="complementaryFoundErrorPick"
                             tOptions={{interpolation: {escapeValue: false}}}
                             components={{
                               Link: <Link className="clickable"
                                           href={"https://help.antennaplus.gr/contact-us/"}
                                           target={"_blank"}/>
                             }}
                      />
                    </span>
                    <div className={"subService-error"} style={{display: "flex", flexDirection: "row", marginTop: "24px"}}>
                      <Button
                          variant="contained"
                          color="primary"
                          className="grey"
                          onClick={() => {
                            navigate('/');
                          }}>
                        {t("goBackButton")}
                      </Button>
                    </div>
                  </GenericError>
                </PopUp>
              </>)}
          {!!phoneNumberVerifyToken &&
              <PhoneVerification phoneNumberVerifyToken={phoneNumberVerifyToken}
                                 triggerNextPopup={()=>{
                                   UserService.setOTPOnActionToken();
                                   setVerificationSent(shouldShowVerifyEmailPopup())
                                 }}
                                 finallyAction={()=>{
                                   checkFlow().then(response =>{
                                     removeLoading("INIT");
                                   })
                                 }}
              />
          }
      </>);
}
export default PickProgram;
